import { httpDelete, httpGet, httpPatch, httpPost } from './api.service';
import { LanguagePreference, TranslationItem } from '../types/Language';

const getAvailableLanguages = async (): Promise<LanguagePreference[]> => {
  return await httpGet<LanguagePreference[]>(`api/language`);
};

const getLanguage = async (isoCode: string) => {
  const response = await httpGet(`api/language/${isoCode}`);
  return response;
};

const addOrUpdateLanguage = async (request: any): Promise<TranslationItem> => {
  return await httpPost(`api/language`, request);
};
const getPreferredLanguage = async () => {
  const response = await httpGet(`api/language/preferred`);
  return response;
};

const updatePreferredLanguage = async (request: any): Promise<TranslationItem> => {
  return await httpPost(`api/language/preferred`, request);
};

const bulkUpdateLanguage = async (isoCode: string, request: any) => {
  return await httpPost(`api/language/${isoCode}`, request);
};

const updateLanguageDisplayName = async (displayName: string, isoCode: string) => {
  return await httpPatch(`api/language/${isoCode}/displayname`, displayName);
};

const deleteLanguage = async (isoCode: string) => {
  return await httpDelete(`api/language/${isoCode}`);
};

const deleteLanguageLabel = async (isoCode: string, label: string) => {
  return await httpDelete(`api/language/${isoCode}/${label}`);
};

export {
  getAvailableLanguages,
  getLanguage,
  addOrUpdateLanguage,
  getPreferredLanguage,
  updatePreferredLanguage,
  bulkUpdateLanguage,
  updateLanguageDisplayName,
  deleteLanguage,
  deleteLanguageLabel,
};
